import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n"; // Import the i18n config
import { Grid, Card, Paper, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";
const DestinationCard = ({ destination ,index}) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={12} md={4} key={index} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                
                <Card  sx={{
                  width: { md: '280px',xs: '80%' },
                  height: { md: '250px',xs: '80%' },
                  // height: "15.625rem",
                    backgroundColor: "rgba(0, 188, 212, 0.1)",
                    border: "2px solid #327d81",
                    borderRadius: "16px",
                    boxShadow: "0 0 30px rgba(50, 125, 129, 0.8)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-10px)",
                      boxShadow: "0 0 20px rgba(50, 125, 129, 0.8)",
                      backgroundColor: "rgba(50, 125, 129, 0.15)",
                    },
                  }}>
                 
                    {destination.images.map((image, index) => (
                      <Paper
                        key={index}
                        elevation={0}
                        sx={{
                          width: { md: '280px',xs: '100%' },
                          height: { md: '250px',xs: '100%' },
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'transparent',
                          position: 'relative',
                          p: 0
                        }}
                      >
                        <Box
                          component="img"
                          src={image}
                          alt={t(`${destination.title}.title`)}
                          sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                          onError={(e) => {
                            console.error(`Failed to load image: ${image}`);
                            e.target.src = '/logo192.png';
                          }}
                        />
                      </Paper>
                    ))}
                 
                    </Card>
                  
                  <Link to={`/details/${index}`} state={{ destination:destination ,index}} style={{ textDecoration: "none" }}>
                  <Typography  component="div" sx={{
                    fontSize: '1.3rem',
                    
                    paddingTop: 2,
                    textAlign: 'center',
                    fontFamily: 'Montserrat',
                    color: '#000000',
                    fontWeight: 600,
                    
                  }}
                  
                  >
                      {t(`${destination.key}.title`)}
                    </Typography>
                    <Typography  sx={{lineHeight: '2',minHeight: '280px',width: { md: '280px',xs: '100%' },marginTop: '10px',fontFamily: 'Noto Sans',color: '#5a5c61',whiteSpace: 'pre-line',}}>
                    {t(`${destination.key}.description`)}
                    </Typography>
                    </Link>
                </Grid>
                
  );
};

export default DestinationCard;
